import { Link } from 'react-router-dom'
import './Header.css'

function Header() {
  return (
    <div className='head'>
      <div className="container-fluid mt-3">
        <div className="row ">
          <div className="col-6">
            <h3>Comfort<span>Limo.</span></h3>
          </div>
          <div className="col-6">
            <ul className='d-flex justify-content-end gap-5'>
            <Link to={'/contact'}><li>Contact Us</li></Link>
            <Link to={'/FAQ'}><li>FAQ</li></Link>
            <Link to={'/terms'}><li>Terms & Conditions</li></Link>
          </ul>
          </div>
          
        </div>
        </div>
      </div>
  )
}

export default Header